export default __webpack_public_path__ + "static/muli-v20-latin-regular-bff5dbd6b18f63c6d17367046ddd305c.eot";